<template>
  <div class="interview-container">
    <GradationMessage class="interview-message">
      <p v-for="(message, i) in messages" :key="i">{{ message }}</p>
    </GradationMessage>
    <!-- インタビューの内容は各社コンポーネントを作成し、以下に設置 -->
    <KinoshitaInterviewContents v-show="company === 'kinoshitanokaigo'"/>
    <MCSInterviewContents v-show="company === 'medicalcareservice'"/>
  </div>
</template>

<script>
import GradationMessage from '@/components/LP/atoms/GradationMessage'
import KinoshitaInterviewContents from '@/components/LP/organisms/KinoshitaInterviewContents'
import MCSInterviewContents from '@/components/LP/organisms/MCSInterviewContents'

export default {
	components: {
    GradationMessage,
    KinoshitaInterviewContents,
    MCSInterviewContents
	},
  props: {
    company: {
      type: String,
    },
  },
  data () {
    // 定数名はパス名（社名）と一致させること
    const kinoshitanokaigo = [
      "◆ 採用側主導の日程調整から、応募者主導の日程調整へ。",
      "◆ 「ヒト」から「ロボ」に。ロボができるものはロボに。ヒトはヒトしかできない事にコミット"
    ]
    const medicalcareservice = [
      "◆ 外国人採用の受け皿を「ヒト」から「ロボ」へ",
    ]
    return {
      // パスを変数名化
      messages: eval(this.company)
    }
  },
}
</script>

<style scoped lang="scss">
.interview-container {
  padding: 80px 40px;
  .interview-message {
    margin: auto;
  }
}
@media screen and (max-width: 896px) {
  .interview-container {
    padding: 40px;
  }
}

@media screen and (max-width: 480px) {
  .interview-container {
    padding: 40px 16px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/LP/organisms/Interview.vue